<div (click)="picker.open()" [formGroup]="dateRange">
  <mat-date-range-input #rangeInput [rangePicker]="picker" [max]="maxDate" [min]="minDate">
    <input matStartDate formControlName="start">
    <input matEndDate formControlName="end">
  </mat-date-range-input>

  <mat-date-range-picker [touchUi]="touchUi" #picker></mat-date-range-picker>

  <ng-content></ng-content>

</div>